import { ConfigurationError } from "@cian/core/errors/index.mjs";
import { ca } from "@cian/analytics";
import { useEffect, useMemo } from "react";
import { ERROR_DOMAIN_BASE, EStatus } from "../../constants.js";
import { useContext } from "../../context/index.js";
const Experiment = ({ name, group, default: default_ = false, children })=>{
    const contextGetter = useContext();
    const { experiments, requestId, requestDate, status } = useMemo(()=>contextGetter(), [
        contextGetter
    ]);
    const isActive = useMemo(()=>{
        if (status === EStatus.Success) {
            if (name in experiments) {
                if (!experiments[name]) return !!default_;
                return experiments[name] === group;
            }
            if ('development' === process.env.NODE_ENV) throw new ConfigurationError({
                message: "\u042D\u043A\u0441\u043F\u0435\u0440\u0438\u043C\u0435\u043D\u0442 \u043D\u0435 \u043D\u0430\u0439\u0434\u0435\u043D. \u041F\u0440\u043E\u0432\u0435\u0440\u044C\u0442\u0435, \u0447\u0442\u043E \u0443\u043A\u0430\u0437\u0430\u043D\u043D\u044B\u0439 \u044D\u043A\u0441\u043F\u0435\u0440\u0438\u043C\u0435\u043D\u0442 \u0431\u044B\u043B \u0437\u0430\u043F\u0440\u043E\u0448\u0435\u043D",
                domain: `${ERROR_DOMAIN_BASE}.Experiment`,
                details: {
                    name
                }
            });
        }
        return !!default_;
    }, [
        status,
        default_,
        name,
        experiments,
        group
    ]);
    useEffect(()=>{
        if (!isActive) return;
        ca('experimentsAbExposure', {
            exposedDate: new Date().toISOString(),
            group,
            libraryVersion: "2.0.1-browserasdefault.0",
            name,
            requestDate,
            requestId
        });
    });
    if (!isActive) return null;
    return children;
};
Experiment.displayName = 'Experiment';
export { Experiment };
